import { appUrls } from "../../utils/urls/appUrls";

import {
  Login,
  Registration,
  ForgotPassword,
  EmailVerificationLinkSentScreen,
  AccountActivation,
  PasswordReset,
  ResetLinkSentScreen,
  PasswordResetSuccess,
} from "../../app/pages";
// import OTPVerification from '../../app/pages/CertificateManagement/BankRep/OTPVerification'
// import LinkVerificationError from '../../app/pages/CertificateManagement/BankRep/LinkVerificationError'

export const onBoardRoutes = [
  //Authentication
  {
    id: 1,
    url: appUrls.login,
    component: <Login />,
    routeType: "public",
  },
  {
    id: 2,
    url: appUrls.register,
    component: <Registration />,
    routeType: "public",
  },
  {
    id: 3,
    url: appUrls.forgotPassword,
    component: <ForgotPassword />,
    routeType: "public",
  },
  {
    id: 4,
    url: appUrls.emailLinkSuccess,
    component: <EmailVerificationLinkSentScreen />,
    routeType: "public",
  },
  {
    id: 5,
    url: appUrls.passwordLinkSuccess,
    component: <ResetLinkSentScreen />,
    routeType: "public",
  },
  {
    id: 6,
    url: appUrls.accountActivation,
    component: <AccountActivation />,
    routeType: "public",
  },
  {
    id: 7,
    url: appUrls.passwordReset,
    component: <PasswordReset />,
    routeType: "public",
  },
  {
    id: 8,
    url: appUrls.passwordResetSuccess,
    component: <PasswordResetSuccess />,
    routeType: "public",
  },
];
